import {Injectable, OnDestroy} from '@angular/core';
@Injectable({
    providedIn: 'platform'
})
export class LoadingIndicatorService implements OnDestroy {
    static instance: LoadingIndicatorService = null;  // Create a singleton service
    elementId: string =  'loading-indicator';
    private static loadingIndicator: LoadingIndicator = null;

    constructor() {
    }
    setElementId(elementId: string){
        this.elementId = elementId;
    }

    getElementId (): string {
        return this.elementId;
    }

    /**
     * Get DOM of loading indicator
     */
    private getIndicator(): LoadingIndicator {
        if (LoadingIndicatorService.loadingIndicator && LoadingIndicatorService.loadingIndicator.container) {
            return LoadingIndicatorService.loadingIndicator;
        }
        // If Loading indicator not exist
        const container = document.getElementById(this.getElementId()) as HTMLElement;
        let loadingElement: HTMLElement;
        let message: string;
        if (container) {
            const elements = container.getElementsByTagName('span');
            if (elements && elements.length > 0) {
                loadingElement = container.getElementsByTagName('span')[0] as HTMLElement;
                if (loadingElement && loadingElement.innerText) {
                    message = loadingElement.innerText;
                }
            }
        }
        // cache Loading indicator
        LoadingIndicatorService.loadingIndicator = new LoadingIndicator(container, loadingElement, message);
        return LoadingIndicatorService.loadingIndicator;
    }

    private getLoadingIndicator(): Promise<LoadingIndicator> {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(this.getIndicator()));
        });
    }

    showLoading(message?: string) {
        this.getLoadingIndicator().then(loadingIndicator => {
            if (loadingIndicator && loadingIndicator.container) {
                if (loadingIndicator.element) {
                    loadingIndicator.element.innerText = message || loadingIndicator.message || loadingIndicator.container.title;
                }
                loadingIndicator.container.style.display = 'block';
            }
        });
    }

    hideLoading() {
        this.getLoadingIndicator().then(loadingIndicator => {
            if(loadingIndicator && loadingIndicator.container) {
                loadingIndicator.container.style.display = 'none';
            }
        });
    }

    complete() {
        this.hideLoading();
    }

    ngOnDestroy() {
        this.complete();
    }
}

export class LoadingIndicator {
    container: HTMLElement;
    element: HTMLElement;
    message: string;

    constructor(container: HTMLElement, el: HTMLElement, msg: string = '') {
        this.container = container;
        this.element = el;
        this.message = msg;
    }
}
